import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentVehicleValuations } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { GetInvestmentVehicleValuationsRes } from '@dealstack/shared/lib/generated';

interface Result {
	valuations?: GetInvestmentVehicleValuationsRes;
	isLoading: boolean;
	isError: boolean;
}

export const useVehicleValuations = ({ personId }: { personId: string }): Result => {
	const valuationsQuery = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_VALUATIONS_GET, { personId }],
		queryFn: ({ signal }) =>
			getInvestmentVehicleValuations(
				API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_VALUATIONS_GET,
				{ personId },
				signal
			),
	});

	return {
		valuations: valuationsQuery.data?.payload,
		isLoading: valuationsQuery.isPending,
		isError: valuationsQuery.isError,
	};
};
